/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  GetTariffMonthlyRatesParams,
  TariffMonthlyRateResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get Tariff monthly rates
 */
export const getTariffMonthlyRates = (
  params: GetTariffMonthlyRatesParams,
  options?: SecondParameter<
    typeof backofficeRequest<TariffMonthlyRateResponse>
  >,
) => {
  return backofficeRequest<TariffMonthlyRateResponse>(
    { url: `/api/v1/tariff/monthly-rates`, method: "GET", params },
    options,
  )
}
export type GetTariffMonthlyRatesResult = NonNullable<
  Awaited<ReturnType<typeof getTariffMonthlyRates>>
>
